import { BudgetValueState, Income, IncomeMonth } from 'common/entities';
import { IMonth } from 'common/types';

export function getMonthPeriod(
  income: Income,
  month: IMonth
): IncomeMonth | undefined {
  return income.periods?.find(
    p => p.year === month.year && p.month === month.month
  );
}

export const getMonthIncomeTotal = (
  selectedIncomes: Record<string, BudgetValueState>
): number =>
  Object.values(selectedIncomes).reduce(
    (sum, current) => (current.selected ? sum + (current.value ?? 0) : sum),
    0
  );
